var map = {
	"./igeretharamban.json": "9c1d",
	"./mizmorletoda.json": "142a",
	"./parashathaman.json": "41f9",
	"./parnasa.json": "c4f3",
	"./perekshira.json": "166e",
	"./pitumhaketoret.json": "330a",
	"./prayers.json": "ab15",
	"./shemaisrael.json": "3d88",
	"./shiramhayam.json": "b5ba",
	"./shlombait.json": "aba8",
	"./tehilim.json": "a46b",
	"./tehilimzivug.json": "2b9f",
	"./thilimlerefua.json": "988e",
	"./tikunhaklali.json": "7652"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7766";